export class Settings {
    public constructor(settings: any) {
        Object.assign(this, settings);
    }
}
export interface Settings {
    base: string;
    url(url: string): string;
    name: string;
    author: string;
    description: string;
    minDate: string;
    mainMenu: Array<{ icon: [string, string]; title: string; to: string; exact: boolean }>;
    errorPages: {
        default: { icon: [string, string]; title: string; message: string; statusCode: number };
        [code: string]: { icon: [string, string]; title: string; message: string; statusCode: number };
    };
    card: string;
    headerLogo: string;
    footerLogo: string;
    fullTermsPDF: string;
    cardTypeQuestionId: string;
    cardTypeAnswerId: string;
    programId: string;

    surveyId: string;
    eligibilityPatientFederalQuestion: string;
    eligibilityPatientFederalAnswer: string;
    eligibilityPatientPrescribedQuestion: string;
    eligibilityPatientPrescribedAnswer: string;
    eligibilityPatientInsuranceQuestion: string;
    eligibilityPatientInsuranceAnswer: string;
    eligibilityPatientCitizenQuestion: string;
    eligibilityPatientCitizenAnswer: string;
    eligibilityPatientAgeQuestion: string;
    eligibilityPatientAgeAnswer: string;
    patientDoesAgreeQuestion: string;
    patientDoesAgreeAnswer: string;
    patientEnrollmentQuestion: string;
    patientEnrollmentAnswer: string;
    patientCertifyQuestion: string;
    patientCertifyAnswerYes: string;
    eligibilityPatientFederalAnswerYes: string;
    eligibilityPatientFederalAnswerNo: string;
    eligibilityPatientPrescribedAnswerYes: string;
    eligibilityPatientPrescribedAnswerNo: string;
    eligibilityPatientInsuranceAnswerYes: string;
    eligibilityPatientInsuranceAnswerNo: string;
    eligibilityPatientCitizenAnswerYes: string;
    eligibilityPatientCitizenAnswerNo: string;
    eligibilityFederal: string;
    eligibilityPrescribed: string;
    eligibilityInsurance: string;
    eligibilityCitizen: string;

    personalInformationQuestion: string;
    personalInformationYes: string;
    personalInformationNo: string;

    doesAgreeMarketingQuestion: string;
    doesAgreeMarketingYes: string;
    doesAgreeMarketingNo: string;

    patientTypeQuestion: string;
    patientTypeYes: string;
    patientTypeNo: string;

    pathQuestion: string;
    pathAnswerPatient: string;
    pathAnswerPharmacy: string;
    
    eligibilityPharmacyFederalQuestion: string;
    eligibilityPharmacyFederalAnswerYes: string;
    eligibilityPharmacyFederalAnswerNo: string;
    eligibilityPharmacyPrescribedQuestion: string;
    eligibilityPharmacyPrescribedAnswerYes: string;
    eligibilityPharmacyPrescribedAnswerno: string;
    eligibilityPharmacyResidesQuestion: string;
    eligibilityPharmacyResidesAnswerYes: string;
    eligibilityPharmacyResidesAnswerNo: string;
    eligibilityPharmacyDoesAgreeQuestion: string;
    eligibilityPharmacyDoesAgreeAnswerYes: string;
    eligibilityPharmacyDoesAgreeAnswerNo: string;
    pharmacyDoesAgreeQuestion: string;
    pharmacyDoesAgreeAnswer: string;
    pharmacyEnrollmentQuestion: string;
    pharmacyEnrollmentAnswer: string;
    pharmacyCertifyQuestion: string;
    pharmacyCertifyAnswerYes: string;

    pharConsentQuestion: string;
    pharConsentYes: string;
    pharConsentNo: string;

    pharCertifyQuestion: string;
    pharCertifyYes: string;
    pharCertifyNo: string;

    headerLeftLogo: string;
    headerRightLogo: string;
    termsAndConditionsPdf: string;
    fullTerms: string;

    triangleUp: string;
    triangleDown: string;
    lockEnabled: string;
    lockPassword: string;
}
